<template>
    <div>
        <el-alert :title="e" v-for="e in errorData" type="error" :closable="true" description="当前单位excel格式错误,需单独下载">
        </el-alert>
        
        <div v-if="isShowProgress" class="popContainer">
            <el-progress :percentage="percentage" :text-inside="true" :stroke-width="24" style="top: 50%; left: 28%; width: 44%"/>
        </div>
        <div style="display: flex;flex-direction: row;align-items: center;height: 100%;"
            v-loading.fullscreen.lock="allLoading">
            <div style="margin-left: 50px;">
                <el-button @click="downloadRaw">开始导出</el-button>
            </div>
            <div style="display: flex;align-items:center;">
                <el-form ref="form" :model="form" label-width="50px">
                    <el-form-item label="年份">
                        <el-radio-group v-model="form.year">
                            <el-radio :label="radioOption">{{radioOption}}年度</el-radio>
                            <el-radio :label="radioOption-1">{{radioOption-1}}年度</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-radio-group v-model="form.type">
                            <el-radio label="ys">预算</el-radio>
                            <el-radio label="js">决算</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div style=" height: 88%;" v-show="show">
                <el-table :data="tableData" ref="tableRef" stripe border height="88%" style="width: 100%"
                    :header-cell-style="headerCellStyle" @selection-change="handleSelectionChange" row-key="id"
                    :tree-props="{children: 'children'}" @select="rowSelect" @select-all="selectAll" default-expand-all>
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column label="单位" prop="name" width="500"> </el-table-column>
                    <el-table-column label="导入状态" sortable :sort-method="sortstate"
                        :filters="stateName().map((e, idx)=>{return { text: e, value: idx };})"
                        :filter-method="filterTag">
                        <template #default="scope">
                            <span>{{ stateName()[scope.row.state] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位编码" prop="code" width="180">
                    </el-table-column>
                </el-table>
            </div>

        </div>


    </div>

</template>
<script>
//批量下载pdf插件
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { getDivsList, downloadRaw } from "@/api/index.js";
export default {
    name: '批量导出公开表',
    data() {
        return {
            tableData: [],
            selectData: [],
            errorData: [],
            form: {
                type: this.$store.state.openType,
                year: this.$store.state.openYear,
            },
            tableHeight: '80%',
            allLoading: false,
            show: true,
            radioOption: this.$store.state.openYear,
            percentage: 0,
            isShowProgress:false
        }
    },
    created() {
        // console.log(this.form)
    },
    mounted() {
        this.getDivsList();
    },
    methods: {
        async getDivsList() {
            this.allLoading = true;
            getDivsList().then(res => {
                this.tableData = res.divs.filter(
                    (e) => e.type != 1
                ).sort(function (a, b) {
                    return a.autoid - b.autoid
                });
            }).catch(e => {
                return e
            })
            this.allLoading = false;
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        sortstate(a, b) {
            return a.state - b.state;
        },
        filterTag(value, row) {
            if (row.state != 0) {
                return row.state == value;
            }

        },
        async downloadRaw() {
            if (this.selectData.length == 0) {
                this.$message("请选择单位");
                return;
            }
            this.isShowProgress = true
            //自定义sleep方法
            function sleep(numberMillis) {
                var now = new Date();
                var exitTime = now.getTime() + numberMillis;
                while (true) {
                    now = new Date();
                    if (now.getTime() > exitTime)
                        return;
                }
            }
            const zip = new JSZip();
            const cache = {};
            const promises = [];
            this.percentage = 0;
            let a = Math.floor(100 / this.selectData.length)
            for (let index = 0; index < this.selectData.length; index++) {
                const element = this.selectData[index];
                let body = {
                    id: element.id,
                    fileid: "",
                    type: this.form.type,
                    year: this.form.year,
                }
                try {
                    if (index != 0) {
                        sleep(3000)
                    }
                    let res = await downloadRaw(body)
                    this.percentage += a
                    // if (res.headers['content-type'] != "application/vnd.ms-excel") {
                    //     this.errorData.push(element.name);
                    // } else {
                        const file_name = element.name + `${res.headers['content-type'] != "application/vnd.ms-excel" ? '.xlsx' : '.xls'}`; // 获取文件名
                        zip.file(file_name, res.data, { binary: true });// 逐个添加文件
                        cache[file_name] = res.data
                        promises.push(res.data)
                    // }
                } catch (error) {
                    this.isShowProgress = false
                    throw error
                }
            }
            if (promises.length > 0) {
                var titlename = "";
                if (localStorage.getItem('titlename')) {
                    titlename = decodeURIComponent(localStorage.getItem('titlename'))
                }
                Promise.all(promises).then(() => {
                    zip.generateAsync({ type: "blob" }).then(content => {// 生成二进制流
                        FileSaver.saveAs(content, titlename + "的" + this.form.year + "年" + (this.form.type == 'js' ? '决算' : '预算') + "公开表.zip") // 利用file-saver保存文件
                    })
                })
            }
            this.isShowProgress = false
        },
    },
}
</script>
<style scoped>
.my-table {
    width: 100%;
    height: 100%;
}

.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, .6);
}
</style>